module.exports = __webpack_public_path__ + "img/the-hundred-thousand-kingdoms.637d33bb.png";